<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listRegistrationsTypes"
        :title-table="$t('Registration Type')"
        module="registrationTypeSettingsModule"
        sort-name="nome"
        :show-btn-add="verificarPermissao('ROLE_ADMIM_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ADMIM_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormRegistrationType v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormRegistrationType from './forms/FormRegistrationType.vue'
import { verificarPermissao } from '@/auth/utils'

export default {
  name: 'RegistrationType',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormRegistrationType
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('registrationTypeSettingsModule', {
      listRegistrationsTypes: (state) => state.listRegistrationsTypes
    })
  },
  data() {
    return {
      verificarPermissao,
      loadingDelete: false,
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id'
        },
        {
          label: this.$t('Description'),
          field: 'nome'
        },
        {
          label: 'Tipo De Cadastro',
          field: 'tipo.nome'
        },
        {
          label: 'Categoria Padrão',
          field: 'tiposFaixaPadrao'
        },
        {
          label: 'Tipo Pagto. Padrão',
          field: 'tipoPagamentoPadrao.descricao'
        },
        {
          label: 'Conta Padrão',
          field: 'contaPadrao.descricao'
        },
        {
          label: this.$t('Active'),
          field: 'ativo'
        },
        {
          label: this.$t('Action'),
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'nome',
        order: 'asc'
      }
    }
  },
  mounted() {
    this.$store.dispatch(
      'registrationTypeSettingsModule/loadTable',
      this.pageConfig
    )
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'registrationTypeSettingsModule/prepareToEditRegistrationType',
        data
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
      this.$store.dispatch(
        'registrationTypeSettingsModule/loadTable',
        this.pageConfig
      )
    }
  }
}
</script>
